import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "maintenance, settings, service" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M9.75893 10.8142C12.2851 10.8142 14.333 8.76628 14.333 6.24009C14.333 5.71258 14.2437 5.20593 14.0794 4.73443L12.2219 6.59194C11.4446 7.36923 10.1844 7.36923 9.40708 6.59194C8.62979 5.81465 8.62979 4.55442 9.40708 3.77713L11.2646 1.91961C10.7931 1.75531 10.2864 1.66602 9.75893 1.66602C7.23274 1.66602 5.18486 3.7139 5.18486 6.24009C5.18486 6.86385 5.30972 7.45845 5.5358 8.00026L2.03962 11.4989C1.64933 11.8895 1.64944 12.5224 2.03987 12.9129L3.08615 13.9592C3.47658 14.3496 4.10955 14.3497 4.50011 13.9594L7.99876 10.4632C8.54057 10.6893 9.13517 10.8142 9.75893 10.8142Z",
        stroke: "#7F7F83",
        "stroke-linejoin": "round"
      })
    ], -1)
  ])))
}
export default { render: render }